/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleContractorVm
 */
export interface SimpleContractorVm {
    /**
     * 
     * @type {string}
     * @memberof SimpleContractorVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleContractorVm
     */
    name?: string | null;
}

export function SimpleContractorVmFromJSON(json: any): SimpleContractorVm {
    return SimpleContractorVmFromJSONTyped(json, false);
}

export function SimpleContractorVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleContractorVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function SimpleContractorVmToJSON(value?: SimpleContractorVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


